var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/hooks/useImagePreview.tsx
import { useState } from "react";
import download from "downloadjs";
var SCALE_STEP = 0.2;
var SCALE_LIMIT = {
  MAX: 5,
  MIN: 0.1
};
var defaultStyle = {
  ratio: 1,
  rotate: 0,
  width: "100%",
  height: "100%",
  defaultWidth: 100,
  defaultHeight: 100,
  defaultRatio: 1
};
function useImagePreview(url, options) {
  const [imageStyle, setImageStyle] = useState(__spreadValues({}, defaultStyle));
  const { onImageDownloadFail } = options != null ? options : {};
  const setZoomSize = (scale) => {
    setImageStyle(__spreadProps(__spreadValues({}, imageStyle), {
      width: `${+(imageStyle.defaultWidth * scale).toFixed(2)}%`,
      height: `${+(imageStyle.defaultHeight * scale).toFixed(2)}%`,
      ratio: scale
    }));
  };
  const handleZoom = (scale) => {
    if (scale > SCALE_LIMIT.MAX) {
      scale = SCALE_LIMIT.MAX;
    } else if (scale < SCALE_LIMIT.MIN) {
      scale = SCALE_LIMIT.MIN;
    }
    scale = Number.parseFloat(`${scale}`);
    setZoomSize(scale);
  };
  const onEnlarge = () => {
    handleZoom(imageStyle.ratio + SCALE_STEP);
  };
  const onShrink = () => {
    handleZoom(imageStyle.ratio - SCALE_STEP);
  };
  const onRotate = () => {
    let rotate = 0;
    if (imageStyle.rotate !== 270) {
      rotate = imageStyle.rotate + 90;
    }
    setImageStyle(__spreadProps(__spreadValues({}, imageStyle), {
      rotate
    }));
  };
  const onRestore = () => {
    setZoomSize(imageStyle.defaultRatio || 1);
  };
  const onDownload = () => {
    const response = download(url);
    if (response instanceof XMLHttpRequest) {
      response.onerror = function() {
        onImageDownloadFail == null ? void 0 : onImageDownloadFail();
      };
    }
  };
  return {
    imageStyle,
    onDownload,
    onEnlarge,
    onRestore,
    onRotate,
    onShrink
  };
}

// src/components/file-preview/index.tsx
import {
  useMemo as useMemo2,
  useState as useState7,
  useEffect as useEffect4,
  useRef as useRef3,
  useImperativeHandle as useImperativeHandle2,
  forwardRef as forwardRef3
} from "react";

// src/shadcn/lib/utils.ts
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// src/components/file-preview/PdfPreview/index.tsx
import { forwardRef as forwardRef2 } from "react";

// src/components/file-preview/PdfPreview/NormalPdfPreview.tsx
import { Document, Page, pdfjs } from "react-pdf";
import styled2 from "@emotion/styled";
import { useState as useState2 } from "react";
import download2 from "downloadjs";

// src/base/components/toast/index.tsx
import { useNotification } from "rc-notification";

// src/assets/svg/error.svg
import * as React from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var SvgError = (props) => /* @__PURE__ */ jsx("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16" }, props), { children: /* @__PURE__ */ jsxs("g", { children: [
  /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("path", { d: "M16,8Q16,8.19639,15.9904,8.39254Q15.9807,8.58869,15.9615,8.78414Q15.9422,8.97958,15.9134,9.17384Q15.8846,9.36811,15.8463,9.56072Q15.808,9.75334,15.7602,9.94384Q15.7125,10.1343,15.6555,10.3223Q15.5985,10.5102,15.5323,10.6951Q15.4662,10.88,15.391,11.0615Q15.3159,11.2429,15.2319,11.4204Q15.1479,11.598,15.0554,11.7712Q14.9628,11.9444,14.8618,12.1128Q14.7609,12.2813,14.6518,12.4446Q14.5426,12.6079,14.4257,12.7656Q14.3087,12.9233,14.1841,13.0751Q14.0595,13.227,13.9276,13.3725Q13.7957,13.518,13.6569,13.6569Q13.518,13.7957,13.3725,13.9276Q13.227,14.0595,13.0751,14.1841Q12.9233,14.3087,12.7656,14.4257Q12.6079,14.5426,12.4446,14.6518Q12.2813,14.7609,12.1128,14.8618Q11.9444,14.9628,11.7712,15.0554Q11.598,15.1479,11.4204,15.2319Q11.2429,15.3159,11.0615,15.391Q10.88,15.4662,10.6951,15.5324Q10.5102,15.5985,10.3223,15.6555Q10.1343,15.7125,9.94384,15.7602Q9.75334,15.808,9.56072,15.8463Q9.36811,15.8846,9.17384,15.9134Q8.97958,15.9422,8.78414,15.9615Q8.58869,15.9807,8.39254,15.9904Q8.19639,16,8,16Q7.80361,16,7.60746,15.9904Q7.4113,15.9807,7.21586,15.9615Q7.02042,15.9422,6.82615,15.9134Q6.63189,15.8846,6.43928,15.8463Q6.24666,15.808,6.05616,15.7602Q5.86565,15.7125,5.67772,15.6555Q5.48979,15.5985,5.30488,15.5323Q5.11997,15.4662,4.93853,15.391Q4.75709,15.3159,4.57956,15.2319Q4.40203,15.1479,4.22883,15.0554Q4.05563,14.9628,3.88718,14.8618Q3.71873,14.7609,3.55544,14.6518Q3.39215,14.5426,3.23441,14.4257Q3.07666,14.3087,2.92485,14.1841Q2.77304,14.0595,2.62753,13.9276Q2.48201,13.7957,2.34315,13.6569Q2.20428,13.518,2.07239,13.3725Q1.9405,13.227,1.81592,13.0751Q1.69133,12.9233,1.57434,12.7656Q1.45735,12.6079,1.34824,12.4446Q1.23914,12.2813,1.13817,12.1128Q1.03721,11.9444,0.94463,11.7712Q0.852053,11.598,0.768086,11.4204Q0.684118,11.2429,0.608964,11.0615Q0.533809,10.88,0.467647,10.6951Q0.401486,10.5102,0.344477,10.3223Q0.287469,10.1343,0.23975,9.94384Q0.192031,9.75334,0.153718,9.56072Q0.115404,9.36811,0.0865879,9.17384Q0.0577717,8.97958,0.0385222,8.78414Q0.0192727,8.58869,0.00963635,8.39254Q0,8.19639,0,8Q0,7.80361,0.00963635,7.60746Q0.0192727,7.4113,0.0385222,7.21586Q0.0577717,7.02042,0.0865879,6.82615Q0.115404,6.63189,0.153718,6.43928Q0.192031,6.24666,0.23975,6.05616Q0.287469,5.86565,0.344477,5.67772Q0.401486,5.48979,0.467647,5.30488Q0.533809,5.11997,0.608964,4.93853Q0.684118,4.75709,0.768086,4.57956Q0.852053,4.40203,0.94463,4.22883Q1.03721,4.05563,1.13817,3.88718Q1.23914,3.71873,1.34824,3.55544Q1.45735,3.39215,1.57434,3.23441Q1.69133,3.07666,1.81592,2.92485Q1.9405,2.77304,2.07239,2.62753Q2.20428,2.48201,2.34315,2.34315Q2.48201,2.20428,2.62753,2.07239Q2.77304,1.9405,2.92485,1.81592Q3.07666,1.69133,3.23441,1.57434Q3.39215,1.45735,3.55544,1.34824Q3.71873,1.23914,3.88718,1.13817Q4.05563,1.03721,4.22883,0.94463Q4.40203,0.852053,4.57956,0.768086Q4.75709,0.684118,4.93853,0.608964Q5.11997,0.533809,5.30488,0.467647Q5.48979,0.401486,5.67772,0.344477Q5.86565,0.287469,6.05616,0.23975Q6.24666,0.192031,6.43928,0.153718Q6.63189,0.115404,6.82615,0.0865879Q7.02042,0.0577717,7.21586,0.0385222Q7.4113,0.0192727,7.60746,0.00963635Q7.80361,0,8,0Q8.19639,0,8.39254,0.00963635Q8.58869,0.0192727,8.78414,0.0385222Q8.97958,0.0577717,9.17384,0.0865879Q9.36811,0.115404,9.56072,0.153718Q9.75334,0.192031,9.94384,0.23975Q10.1343,0.287469,10.3223,0.344477Q10.5102,0.401486,10.6951,0.467647Q10.88,0.533809,11.0615,0.608964Q11.2429,0.684118,11.4204,0.768086Q11.598,0.852053,11.7712,0.94463Q11.9444,1.03721,12.1128,1.13817Q12.2813,1.23914,12.4446,1.34824Q12.6079,1.45735,12.7656,1.57434Q12.9233,1.69133,13.0751,1.81592Q13.227,1.9405,13.3725,2.07239Q13.518,2.20428,13.6569,2.34315Q13.7957,2.48201,13.9276,2.62753Q14.0595,2.77304,14.1841,2.92485Q14.3087,3.07666,14.4257,3.23441Q14.5426,3.39215,14.6518,3.55544Q14.7609,3.71873,14.8618,3.88718Q14.9628,4.05563,15.0554,4.22883Q15.1479,4.40203,15.2319,4.57956Q15.3159,4.75709,15.391,4.93853Q15.4662,5.11997,15.5324,5.30488Q15.5985,5.48979,15.6555,5.67772Q15.7125,5.86565,15.7602,6.05616Q15.808,6.24666,15.8463,6.43928Q15.8846,6.63189,15.9134,6.82615Q15.9422,7.02042,15.9615,7.21586Q15.9807,7.4113,15.9904,7.60746Q16,7.80361,16,8Z", fill: "#FF5219", fillOpacity: 1 }) }),
  /* @__PURE__ */ jsx("g", { children: /* @__PURE__ */ jsx("path", { d: "M9.12475171875,7.999994140625001L11.51622171875,10.391464140625Q11.57164171875,10.446884140625,11.61518171875,10.512044140625001Q11.65872171875,10.577214140625,11.68871171875,10.649624140625Q11.71871171875,10.722034140625,11.734001718750001,10.798904140625Q11.749291718750001,10.875764140625,11.749291718750001,10.954144140625Q11.749291718750001,11.032514140625,11.734001718750001,11.109384140625Q11.71871171875,11.186254140625,11.68871171875,11.258664140625001Q11.65872171875,11.331074140624999,11.61518171875,11.396234140625001Q11.57164171875,11.461404140625,11.51622171875,11.516824140625001Q11.46080171875,11.572244140625,11.39563171875,11.615784140625Q11.330471718750001,11.659324140625,11.25806171875,11.689314140625001Q11.18565171875,11.719314140625,11.10878171875,11.734604140624999Q11.031911718749999,11.749894140624999,10.95354171875,11.749894140624999Q10.87516171875,11.749894140624999,10.79830171875,11.734604140624999Q10.72143171875,11.719314140625,10.64902171875,11.689314140625001Q10.57661171875,11.659324140625,10.51144171875,11.615784140625Q10.44628171875,11.572244140625,10.39086171875,11.516824140625001L7.99939171875,9.125354140625L5.60792171875,11.516824140625001Q5.55250171875,11.572244140625,5.48733171875,11.615784140625Q5.42216171875,11.659324140625,5.34976171875,11.689314140625001Q5.27735171875,11.719314140625,5.20048071875,11.734604140624999Q5.12361271875,11.749894140624999,5.04523771875,11.749894140624999Q4.96686371875,11.749894140624999,4.88999471875,11.734604140624999Q4.81312671875,11.719314140625,4.74071771875,11.689314140625001Q4.66830971875,11.659324140625,4.60314371875,11.615784140625Q4.53797771875,11.572244140625,4.48255871875,11.516824140625001Q4.42713971875,11.461404140625,4.38359671875,11.396234140625001Q4.34005471875,11.331074140624999,4.31006211875,11.258664140625001Q4.28006951875,11.186254140625,4.26477941875,11.109384140625Q4.24948933785,11.032514140625,4.24948933785,10.954144140625Q4.24948933785,10.875764140625,4.26477941875,10.798904140625Q4.28006951875,10.722034140625,4.31006211875,10.649624140625Q4.34005471875,10.577214140625,4.38359671875,10.512054140625Q4.42713971875,10.446884140625,4.48255871875,10.391464140625L6.87403171875,7.999994140625001L4.48273071875,5.6086941406249995Q4.37080671875,5.496764140625,4.31023431875,5.350534140625Q4.24966155875,5.204297140625,4.24966155875,5.046012140625Q4.24966155875,4.887728140625,4.31023431875,4.741493140625Q4.37080671875,4.595257140625,4.48273071875,4.483333140625Q4.53814971875,4.427914140625,4.60331571875,4.384372140625Q4.66848171875,4.340829540625,4.74089071875,4.310836940625Q4.81329871875,4.280844340625,4.89016771875,4.265554240625Q4.96703571875,4.250264164725,5.04540971875,4.250264164725Q5.12378471875,4.250264164725,5.20065271875,4.265554240625Q5.27752171875,4.280844340625,5.34993171875,4.310836940625Q5.42234171875,4.340829540625,5.48750171875,4.384372140625Q5.55267171875,4.427914140625,5.60809171875,4.483333140625L7.99939171875,6.874634140625L10.39069171875,4.483333140625Q10.44611171875,4.427914140625,10.511271718749999,4.384372140625Q10.57644171875,4.340829540625,10.648851718749999,4.310836940625Q10.72126171875,4.280844340625,10.79812171875,4.265554240625Q10.87499171875,4.250264199625,10.953371718749999,4.250264199625Q11.03174171875,4.250264199625,11.10861171875,4.265554240625Q11.185481718750001,4.280844340625,11.257891718749999,4.310836940625Q11.33029171875,4.340829540625,11.39546171875,4.384372140625Q11.460631718750001,4.427914140625,11.516051718749999,4.483333140625Q11.57147171875,4.538752140625,11.61501171875,4.603918140625Q11.658551718750001,4.669084140625,11.688541718749999,4.741493140625Q11.71853171875,4.813901140625,11.73382171875,4.890770140625Q11.74912171875,4.967638140625,11.74912171875,5.046013140625Q11.74912171875,5.124387140625,11.73382171875,5.201256140625Q11.71853171875,5.278124140625,11.688541718749999,5.350534140625Q11.658551718750001,5.422944140625,11.61501171875,5.4881041406249995Q11.57147171875,5.553274140625,11.516051718749999,5.6086941406249995L9.12475171875,7.999994140625001Z", fillRule: "evenodd", fill: "#FFFFFF", fillOpacity: 1 }) })
] }) }));

// src/assets/svg/success.svg
import * as React2 from "react";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var SvgSuccess = (props) => /* @__PURE__ */ jsx2("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", fill: "none", width: 16, height: 16, viewBox: "0 0 16 16" }, props), { children: /* @__PURE__ */ jsx2("g", { children: /* @__PURE__ */ jsxs2("g", { children: [
  /* @__PURE__ */ jsx2("g", { style: {
    opacity: 0
  }, children: /* @__PURE__ */ jsx2("rect", { x: 0, y: 0, width: 16, height: 16, rx: 0, fill: "#D8D8D8", fillOpacity: 1 }) }),
  /* @__PURE__ */ jsx2("g", { children: /* @__PURE__ */ jsx2("path", { d: "M15,8Q15,8.17184,14.9916,8.34347Q14.9831,8.51511,14.9663,8.686119999999999Q14.9494,8.85713,14.9242,9.02711Q14.899,9.19709,14.8655,9.36563Q14.832,9.53417,14.7902,9.70086Q14.7485,9.86755,14.6986,10.03199Q14.6487,10.19643,14.5908,10.35823Q14.5329,10.52002,14.4672,10.67878Q14.4014,10.83754,14.3279,10.99288Q14.2545,11.1482,14.1734,11.2998Q14.0924,11.4513,14.0041,11.5987Q13.9158,11.7461,13.8203,11.889Q13.7248,12.0319,13.6225,12.1699Q13.5201,12.3079,13.4111,12.4408Q13.3021,12.5736,13.1867,12.7009Q13.0713,12.8282,12.9497,12.9497Q12.8282,13.0713,12.7009,13.1867Q12.5736,13.3021,12.4408,13.4111Q12.3079,13.5201,12.1699,13.6225Q12.0319,13.7248,11.889,13.8203Q11.7461,13.9158,11.5987,14.0041Q11.4513,14.0924,11.2998,14.1734Q11.1482,14.2545,10.99288,14.3279Q10.83754,14.4014,10.67878,14.4672Q10.52002,14.5329,10.35823,14.5908Q10.19643,14.6487,10.03199,14.6986Q9.86755,14.7485,9.70086,14.7902Q9.53417,14.832,9.36563,14.8655Q9.19709,14.899,9.02711,14.9242Q8.85713,14.9494,8.686119999999999,14.9663Q8.51511,14.9831,8.34347,14.9916Q8.17184,15,8,15Q7.82816,15,7.65653,14.9916Q7.48489,14.9831,7.31388,14.9663Q7.14287,14.9494,6.97289,14.9242Q6.80291,14.899,6.63437,14.8655Q6.46583,14.832,6.29914,14.7902Q6.13245,14.7485,5.96801,14.6986Q5.80357,14.6487,5.64177,14.5908Q5.47998,14.5329,5.32122,14.4672Q5.16246,14.4014,5.00711,14.3279Q4.85177,14.2545,4.70022,14.1734Q4.5486699999999995,14.0924,4.40128,14.0041Q4.25389,13.9158,4.11101,13.8203Q3.96813,13.7248,3.8301,13.6225Q3.69208,13.5201,3.55925,13.4111Q3.42641,13.3021,3.29909,13.1867Q3.17176,13.0713,3.05025,12.9497Q2.92874,12.8282,2.81334,12.7009Q2.69794,12.5736,2.58893,12.4408Q2.4799100000000003,12.3079,2.3775500000000003,12.1699Q2.2751799999999998,12.0319,2.17971,11.889Q2.0842400000000003,11.7461,1.9959,11.5987Q1.907556,11.4513,1.826551,11.2998Q1.745546,11.1482,1.672075,10.99288Q1.598604,10.83754,1.532843,10.67878Q1.4670830000000001,10.52002,1.409191,10.35823Q1.3513,10.19643,1.301418,10.03199Q1.251535,9.86755,1.209781,9.70086Q1.168027,9.53417,1.134503,9.36563Q1.100979,9.19709,1.0757644,9.02711Q1.0505502,8.85713,1.0337069,8.686119999999999Q1.0168636,8.51511,1.0084318,8.34347Q1,8.17184,1,8Q1,7.82816,1.0084318,7.65653Q1.0168636,7.48489,1.0337069,7.31388Q1.0505502,7.14287,1.0757644,6.97289Q1.100979,6.80291,1.134503,6.63437Q1.168027,6.46583,1.209781,6.29914Q1.251535,6.13245,1.301418,5.96801Q1.3513,5.80357,1.409191,5.64177Q1.4670830000000001,5.47998,1.532843,5.32122Q1.598604,5.16246,1.672075,5.00711Q1.745546,4.85177,1.826551,4.70022Q1.907556,4.5486699999999995,1.995899,4.40128Q2.0842400000000003,4.25389,2.17971,4.11101Q2.2751799999999998,3.96813,2.3775500000000003,3.8301Q2.4799100000000003,3.69208,2.58893,3.55925Q2.69794,3.42641,2.81334,3.29909Q2.92874,3.17176,3.05025,3.05025Q3.17176,2.92874,3.29909,2.81334Q3.42641,2.69794,3.55925,2.58893Q3.69208,2.4799100000000003,3.8301,2.3775500000000003Q3.96813,2.2751799999999998,4.11101,2.17971Q4.25389,2.0842400000000003,4.40128,1.9959Q4.5486699999999995,1.907556,4.70022,1.826551Q4.85177,1.745546,5.00711,1.672075Q5.16246,1.598604,5.32122,1.532843Q5.47998,1.4670830000000001,5.64177,1.409191Q5.80357,1.3513,5.96801,1.301418Q6.13245,1.251535,6.29914,1.209781Q6.46583,1.168027,6.63437,1.134503Q6.80291,1.100979,6.97289,1.0757644Q7.14287,1.0505502,7.31388,1.0337069Q7.48489,1.0168636,7.65653,1.0084318Q7.82816,1,8,1Q8.17184,1,8.34347,1.0084318Q8.51511,1.0168636,8.686119999999999,1.0337069Q8.85713,1.0505502,9.02711,1.0757644Q9.19709,1.100979,9.36563,1.134503Q9.53417,1.168027,9.70086,1.209781Q9.86755,1.251535,10.03199,1.301418Q10.19643,1.3513,10.35823,1.409191Q10.52002,1.4670830000000001,10.67878,1.532843Q10.83754,1.598604,10.99288,1.672075Q11.1482,1.745546,11.2998,1.826551Q11.4513,1.907556,11.5987,1.995899Q11.7461,2.0842400000000003,11.889,2.17971Q12.0319,2.2751799999999998,12.1699,2.3775500000000003Q12.3079,2.4799100000000003,12.4408,2.58893Q12.5736,2.69794,12.7009,2.81334Q12.8282,2.92874,12.9497,3.05025Q13.0713,3.17176,13.1867,3.29909Q13.3021,3.42641,13.4111,3.55925Q13.5201,3.69208,13.6225,3.8301Q13.7248,3.96813,13.8203,4.11101Q13.9158,4.25389,14.0041,4.40128Q14.0924,4.5486699999999995,14.1734,4.70022Q14.2545,4.85177,14.3279,5.00711Q14.4014,5.16246,14.4672,5.32122Q14.5329,5.47998,14.5908,5.64177Q14.6487,5.80357,14.6986,5.96801Q14.7485,6.13245,14.7902,6.29914Q14.832,6.46583,14.8655,6.63437Q14.899,6.80291,14.9242,6.97289Q14.9494,7.14287,14.9663,7.31388Q14.9831,7.48489,14.9916,7.65653Q15,7.82816,15,8Z", fill: "#00B078", fillOpacity: 1 }) }),
  /* @__PURE__ */ jsx2("g", { children: /* @__PURE__ */ jsx2("path", { d: "M11.638168046875,5.36176590625C11.884808046875001,5.60841290625,11.897798046875,6.00024090625,11.677108046875,6.26217390625L11.638168046875,6.30457390625L7.304828046875,10.63790390625C7.043598046875,10.89914390625,6.623318046875,10.89625390625,6.365398046875001,10.641323906250001L6.327968046875,10.60119390625L4.327964046875,8.27555390625C4.087893446875,7.99639390625,4.119580446875,7.57547390625,4.398739046875,7.33540390625C4.663940046875,7.10734390625,5.057080046875,7.12453390625,5.301558046875,7.36616390625L5.338888046875,7.40618390625L6.870098046875,9.18650390625L10.695358046875,5.36176590625C10.955708046875,5.10141650625,11.377818046875,5.10141650625,11.638168046875,5.36176590625Z", fill: "#FFFFFF", fillOpacity: 1 }) })
] }) }) }));

// src/base/components/toast/index.tsx
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var motion = {
  motionName: "rc-notification-fade",
  motionAppear: true,
  motionEnter: true,
  motionLeave: true
};
function useToast() {
  const [{ open, close }, contextHolder] = useNotification({
    motion,
    closable: false
  });
  const renderIcon = (_type) => {
    if (_type === "success") {
      return /* @__PURE__ */ jsx3("div", { className: "ui-w-4 ui-h-4 ui-mr-3", children: /* @__PURE__ */ jsx3(SvgSuccess, {}) });
    }
    if (_type === "error") {
      return /* @__PURE__ */ jsx3("div", { className: "ui-w-4 ui-h-4 ui-mr-3", children: /* @__PURE__ */ jsx3(SvgError, {}) });
    }
    return null;
  };
  const handleOpen = (openConfig) => {
    const { duration = 2e3, type, content } = openConfig;
    const key = String(Math.random());
    open({
      placement: "top",
      key,
      content: /* @__PURE__ */ jsxs3("div", { className: "ui-flex  ui-items-center ui-rounded-xl ui-bg-white ui-px-2", children: [
        renderIcon(type),
        /* @__PURE__ */ jsx3("div", { className: "ui-text-yeah", children: content })
      ] })
    });
    setTimeout(() => {
      close(key);
    }, duration);
  };
  return [handleOpen, contextHolder];
}
var toast_default = useToast;

// src/components/file-preview/ViewControl.tsx
import styled from "@emotion/styled";

// src/assets/svg/chongshi.svg
import * as React3 from "react";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var SvgChongshi = (props) => /* @__PURE__ */ jsxs4("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", className: "o16qtq9z2__design-iconfont", width: 128, height: 128 }, props), { children: [
  /* @__PURE__ */ jsx4("defs", { children: /* @__PURE__ */ jsx4("clipPath", { id: "o16qtq9z2__pyokasid1__em4gqw0vxa", children: /* @__PURE__ */ jsx4("rect", { width: 12, height: 12, rx: 0 }) }) }),
  /* @__PURE__ */ jsx4("g", { clipPath: "url(#o16qtq9z2__pyokasid1__em4gqw0vxa)", children: /* @__PURE__ */ jsx4("path", { d: "M11.14263359375,4.501587734375001L11.14263359375,2.503657734375Q11.14263359375,2.210527734375,10.95723359375,2.024757734375Q10.77154359375,1.838758734375,10.47840359375,1.8387577343750001Q10.18526359375,1.8387577343750001,9.99960359375,2.024757734375Q9.81416359375,2.210527734375,9.81416359375,2.503657734375L9.81416359375,2.526357734375Q9.08476359375,1.692158734375,8.04813359375,1.301552734375Q6.11777359375,0.452475734375,4.13590359375,1.225748734375Q2.1526035937500003,1.999577734375,1.30224659375,3.935667734375Q0.45222659375,5.870997734375,1.22473759375,7.858037734375Q1.99711359375,9.844727734375,3.92985359375,10.696657734375Q5.86227359375,11.548477734375,7.84631359375,10.774327734375Q9.82961359375,10.000497734375,10.67997359375,8.064407734375L10.78180359375,7.832557734375L10.62754359375,7.832557734375Q10.58871359375,7.649397734375,10.45862359375,7.519067734375Q10.27295359375,7.333067734375,9.97981359375,7.333067734375Q9.68667359375,7.333067734375,9.50101359375,7.519067734375Q9.36617359375,7.654147734375,9.32938359375,7.845977734375L9.28919359375,7.913067734375Q8.604553593750001,9.056197734375,7.42362359375,9.543327734375Q5.96016359375,10.151217734375,4.51067359375,9.531657734375Q3.06689359375,8.914537734375,2.45465359375,7.435307734375Q1.84588059375,5.964457734375,2.46661359375,4.497277734375Q3.08642359375,3.032317734375,4.55573359375,2.4578877343750003L4.5585235937499995,2.456797734375L4.56127359375,2.455607734375Q5.86741359375,1.889777734375,7.22568359375,2.372297734375Q8.422223593750001,2.7973677343750003,9.13081359375,3.836687734375L8.48405359375,3.836687734375Q8.19091359375,3.836687734375,8.00524359375,4.022687734374999Q7.81980359375,4.208457734375,7.81980359375,4.501587734375001Q7.81980359375,4.794717734375,8.00524359375,4.980487734375Q8.19091359375,5.166487734375,8.48405359375,5.166487734375L10.47840359375,5.166487734375Q10.77154359375,5.166487734375,10.95723359375,4.980487734375Q11.14263359375,4.794717734375,11.14263359375,4.501587734375001Z", fillRule: "evenodd" }) })
] }));

// src/assets/svg/fangda.svg
import * as React4 from "react";
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var SvgFangda = (props) => /* @__PURE__ */ jsxs5("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "hxibgjued__design-iconfont", width: 128, height: 128 }, props), { children: [
  /* @__PURE__ */ jsx5("defs", { children: /* @__PURE__ */ jsx5("clipPath", { id: "hxibgjued__ia6iwj071__omtxcut9pa", children: /* @__PURE__ */ jsx5("rect", { width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx5("g", { clipPath: "url(#hxibgjued__ia6iwj071__omtxcut9pa)", children: /* @__PURE__ */ jsx5("path", { d: "M11.732825,10.60626140625L14.246825,13.12029140625C14.564025,13.43749140625,14.564025,13.95159140625,14.246925,14.26719140625C13.929725,14.58279140625,13.415625,14.58279140625,13.100025,14.26559140625L10.587495,11.75309140625C9.606245,12.48599140625,8.414065,12.88279140625,7.189065,12.88279140625C4.056255,12.88279140625,1.515625,10.34220140625,1.515625,7.20939140625C1.515625,5.98439140625,1.9125,4.792201406249999,2.643755,3.81095140625C4.520315,1.30001340625,8.074995000000001,0.78751440625,10.585935,2.6640714062499997C13.096925,4.54064140625,13.609425,8.09689140625,11.732825,10.60626140625ZM3.079685,7.26564140625C3.110935,9.50470140625,4.951565,11.29220140625,7.189065,11.26095140625C9.428125,11.26095140625,11.242185,9.448451406250001,11.242185,7.20939140625C11.242185,4.970331406250001,9.426565,3.15626140625,7.189065,3.15626140625L7.074995,3.15626140625C4.835935,3.18751140625,3.048435,5.02658140625,3.079685,7.26564140625ZM6.379085,5.58828140625C6.379085,5.1398414062499995,6.743155,4.777341406250001,7.190025,4.777341406250001C7.638465,4.777341406250001,8.000965,5.1398414062499995,8.000965,5.58828140625L8.000965,6.39845140625L8.810935,6.39845140625C9.259375,6.39845140625,9.621875,6.76251140625,9.621875,7.20939140625C9.621875,7.65782140625,9.257815,8.02032140625,8.810935,8.02032140625L8.000965,8.02032140625L8.000965,8.83047140625C8.000965,9.27891140625,7.636905,9.64141140625,7.190025,9.64141140625C6.741585,9.64141140625,6.379085,9.277341406249999,6.379085,8.83047140625L6.379085,8.02032140625L5.568745,8.02032140625C5.120315,8.02032140625,4.757815,7.65626140625,4.757815,7.20939140625C4.757815,6.76095140625,5.120315,6.39845140625,5.568745,6.39845140625L6.379085,6.39845140625L6.379085,5.58828140625Z", fillRule: "evenodd" }) })
] }));

// src/assets/svg/suoxiao.svg
import * as React5 from "react";
import { jsx as jsx6, jsxs as jsxs6 } from "react/jsx-runtime";
var SvgSuoxiao = (props) => /* @__PURE__ */ jsxs6("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "gwnus6p2a__design-iconfont", width: 128, height: 128 }, props), { children: [
  /* @__PURE__ */ jsx6("defs", { children: /* @__PURE__ */ jsx6("clipPath", { id: "gwnus6p2a__jr95l4atg__wjr5qmzr5a", children: /* @__PURE__ */ jsx6("rect", { width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx6("g", { clipPath: "url(#gwnus6p2a__jr95l4atg__wjr5qmzr5a)", children: /* @__PURE__ */ jsx6("path", { d: "M14.246825,13.12029140625L11.732825,10.60626140625C13.609425,8.09689140625,13.096925,4.54064140625,10.585935,2.6640714062499997C8.074995000000001,0.78751440625,4.520315,1.30001340625,2.643755,3.81095140625C1.9125,4.792201406249999,1.515625,5.98439140625,1.515625,7.20939140625C1.515625,10.34220140625,4.056255,12.88279140625,7.189065,12.88279140625C8.414065,12.88279140625,9.606245,12.48599140625,10.587495,11.75309140625L13.100025,14.26559140625C13.415625,14.58279140625,13.929725,14.58279140625,14.246925,14.26719140625C14.564025,13.95159140625,14.564025,13.43749140625,14.246825,13.12029140625ZM7.189065,11.26095140625C4.951565,11.29220140625,3.110935,9.50470140625,3.079685,7.26564140625C3.048435,5.02658140625,4.835935,3.18751140625,7.074995,3.15626140625L7.189065,3.15626140625C9.426565,3.15626140625,11.242185,4.970331406250001,11.242185,7.20939140625C11.242185,9.448451406250001,9.428125,11.26095140625,7.189065,11.26095140625ZM4.757815,7.20939140625C4.757815,7.65626140625,5.120315,8.02032140625,5.568745,8.02032140625L8.810935,8.02032140625C9.257815,8.02032140625,9.621875,7.65782140625,9.621875,7.20939140625C9.621875,6.76251140625,9.259375,6.39845140625,8.810935,6.39845140625L5.568745,6.39845140625C5.120315,6.39845140625,4.757815,6.76095140625,4.757815,7.20939140625Z" }) })
] }));

// src/assets/svg/xiazai.svg
import * as React6 from "react";
import { jsx as jsx7, jsxs as jsxs7 } from "react/jsx-runtime";
var SvgXiazai = (props) => /* @__PURE__ */ jsxs7("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "tdu81gdba__h049ci3f8__design-iconfont tdu81gdba__design-iconfont", width: 128, height: 128 }, props), { children: [
  /* @__PURE__ */ jsx7("defs", { children: /* @__PURE__ */ jsx7("clipPath", { id: "tdu81gdba__boigd8k5x__c8kyv3t8da", children: /* @__PURE__ */ jsx7("rect", { width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx7("g", { clipPath: "url(#tdu81gdba__boigd8k5x__c8kyv3t8da)", children: /* @__PURE__ */ jsx7("path", { d: "M3.4857899999999997,6.131305805053711L6.00579,6.131305805053711L6.00579,2.521962805053711C6.00574,2.237112805053711,6.24147,2.004706385053711,6.53579,1.9994316100537108L9.53579,1.9994316100537108C9.80641,2.0336561050537107,10.0081,2.257883805053711,10.00579,2.521962805053711L10.00579,6.131305805053711L12.5158,6.131305805053711C12.7107,6.124965805053711,12.8895,6.235795805053711,12.9649,6.409815805053711C13.0404,6.583845805053711,12.997,6.784905805053711,12.8558,6.915095805053711L8.345790000000001,11.288885805053711C8.15821,11.471035805053711,7.85338,11.471035805053711,7.66579,11.288885805053711L3.14579,6.915095805053711C3.0045900000000003,6.784905805053711,2.961157,6.583845805053711,3.03665,6.409815805053711C3.11214,6.235795805053711,3.29086,6.124965805053711,3.4857899999999997,6.131305805053711ZM2,13.69971580505371L2,13.69971580505371Q2,13.630815805053711,2.0134503,13.56311580505371Q2.0269006,13.49551580505371,2.0532843,13.431815805053711Q2.079668,13.36811580505371,2.117971,13.31081580505371Q2.156274,13.253515805053711,2.205025,13.204715805053711Q2.2537760000000002,13.15601580505371,2.311101,13.117715805053711Q2.368426,13.079415805053712,2.432122,13.053015805053711Q2.495817,13.02661580505371,2.563437,13.013115805053712Q2.631056,12.999715805053711,2.7,12.999715805053711L13.3,12.999715805053711Q13.3689,12.999715805053711,13.4366,13.013215805053711Q13.5042,13.02661580505371,13.5679,13.053015805053711Q13.6316,13.079415805053712,13.6889,13.117715805053711Q13.7462,13.15601580505371,13.795,13.204715805053711Q13.8437,13.253515805053711,13.882,13.31081580505371Q13.9203,13.36811580505371,13.9467,13.431815805053711Q13.9731,13.49551580505371,13.9865,13.56311580505371Q14,13.630815805053711,14,13.69971580505371L14,13.69971580505371Q14,13.768615805053711,13.9865,13.836315805053712Q13.9731,13.90391580505371,13.9467,13.967615805053711Q13.9203,14.03131580505371,13.882,14.088615805053712Q13.8437,14.145915805053711,13.795,14.194715805053711Q13.7462,14.243415805053711,13.6889,14.281715805053711Q13.6316,14.32001580505371,13.5679,14.346415805053711Q13.5042,14.372815805053712,13.4366,14.38621580505371Q13.3689,14.399715805053711,13.3,14.399715805053711L2.7,14.399715805053711Q2.631056,14.399715805053711,2.563437,14.38621580505371Q2.495817,14.372815805053712,2.432122,14.346415805053711Q2.368426,14.32001580505371,2.311101,14.281715805053711Q2.2537760000000002,14.243415805053711,2.205025,14.194715805053711Q2.156274,14.145915805053711,2.117971,14.088615805053712Q2.079668,14.03131580505371,2.0532843,13.967615805053711Q2.0269006,13.90391580505371,2.0134503,13.836315805053712Q2,13.768615805053711,2,13.69971580505371Z" }) })
] }));

// src/assets/svg/shiyinghuabu.svg
import * as React7 from "react";
import { jsx as jsx8, jsxs as jsxs8 } from "react/jsx-runtime";
var SvgShiyinghuabu = (props) => /* @__PURE__ */ jsxs8("svg", __spreadProps(__spreadValues({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", className: "oviqh52he__design-iconfont", width: 128, height: 128 }, props), { children: [
  /* @__PURE__ */ jsx8("defs", { children: /* @__PURE__ */ jsx8("clipPath", { id: "oviqh52he__5ha6kerk0__nmg9hueg4a", children: /* @__PURE__ */ jsx8("rect", { y: 16, width: 16, height: 16, rx: 0 }) }) }),
  /* @__PURE__ */ jsx8("g", { transform: "rotate(-90 0 16)", clipPath: "url(#oviqh52he__5ha6kerk0__nmg9hueg4a)", children: /* @__PURE__ */ jsx8("path", { d: "M1.5,18.5L1.5,21.5Q1.5,21.598489999999998,1.5192147,21.69509Q1.5384294,21.79169,1.5761205,21.88268Q1.613811,21.97368,1.66853,22.05557Q1.723249,22.13746,1.792893,22.20711Q1.862537,22.27675,1.94443,22.33147Q2.026322,22.38619,2.1173159999999998,22.42388Q2.208311,22.461570000000002,2.30491,22.48078Q2.401509,22.5,2.5,22.5Q2.59849,22.5,2.69509,22.48078Q2.79169,22.461570000000002,2.8826799999999997,22.42388Q2.97368,22.38619,3.05557,22.33147Q3.13746,22.27675,3.20711,22.20711Q3.27675,22.13746,3.33147,22.05557Q3.38619,21.97368,3.42388,21.88268Q3.46157,21.79169,3.48079,21.69509Q3.5,21.598489999999998,3.5,21.5L3.5,19.5L5.5,19.5C6.05228,19.5,6.5,19.05228,6.5,18.5C6.5,17.947715,6.05228,17.5,5.5,17.5L2.5,17.5Q2.401509,17.5,2.30491,17.5192147Q2.208311,17.5384294,2.1173159999999998,17.5761205Q2.026322,17.613811,1.94443,17.66853Q1.862537,17.723249,1.792893,17.792893Q1.723249,17.862537,1.66853,17.94443Q1.613811,18.026322,1.5761205,18.117316Q1.5384294,18.208311,1.5192147,18.30491Q1.5,18.401509,1.5,18.5ZM14.5,18.5L14.5,21.5Q14.5,21.598489999999998,14.4808,21.69509Q14.4616,21.79169,14.4239,21.88268Q14.3862,21.97368,14.3315,22.05557Q14.2767,22.13746,14.2071,22.20711Q14.1375,22.27675,14.0556,22.33147Q13.9737,22.38619,13.8827,22.42388Q13.7917,22.461570000000002,13.6951,22.48078Q13.5985,22.5,13.5,22.5Q13.4015,22.5,13.3049,22.48078Q13.2083,22.461570000000002,13.1173,22.42388Q13.0263,22.38619,12.9444,22.33147Q12.8625,22.27675,12.7929,22.20711Q12.7232,22.13746,12.6685,22.05557Q12.6138,21.97368,12.5761,21.88268Q12.5384,21.79169,12.5192,21.69509Q12.5,21.598489999999998,12.5,21.5L12.5,19.5L10.5,19.5C9.94772,19.5,9.5,19.05228,9.5,18.5C9.5,17.947715,9.94772,17.5,10.5,17.5L13.5,17.5Q13.5985,17.5,13.6951,17.5192147Q13.7917,17.5384294,13.8827,17.5761205Q13.9737,17.613811,14.0556,17.66853Q14.1375,17.723249,14.2071,17.792893Q14.2767,17.862537,14.3315,17.94443Q14.3862,18.026322,14.4239,18.117316Q14.4616,18.208311,14.4808,18.30491Q14.5,18.401509,14.5,18.5ZM1.5,29.5L1.5,26.5Q1.5,26.401510000000002,1.5192147,26.30491Q1.5384294,26.20831,1.5761205,26.11732Q1.613811,26.02632,1.66853,25.94443Q1.723249,25.86254,1.792893,25.79289Q1.862537,25.72325,1.94443,25.66853Q2.026322,25.61381,2.1173159999999998,25.57612Q2.208311,25.538429999999998,2.30491,25.51921Q2.401509,25.5,2.5,25.5Q2.59849,25.5,2.69509,25.51921Q2.79169,25.538429999999998,2.8826799999999997,25.57612Q2.97368,25.61381,3.05557,25.66853Q3.13746,25.72325,3.20711,25.79289Q3.27675,25.86254,3.33147,25.94443Q3.38619,26.02632,3.42388,26.11732Q3.46157,26.20831,3.48079,26.30491Q3.5,26.401510000000002,3.5,26.5L3.5,28.5L5.5,28.5C6.05228,28.5,6.5,28.947699999999998,6.5,29.5C6.5,30.052300000000002,6.05228,30.5,5.5,30.5L2.5,30.5Q2.401509,30.5,2.30491,30.480800000000002Q2.208311,30.4616,2.1173159999999998,30.4239Q2.026322,30.386200000000002,1.94443,30.3315Q1.862537,30.276699999999998,1.792893,30.2071Q1.723249,30.1375,1.66853,30.0556Q1.613811,29.9737,1.5761205,29.8827Q1.5384294,29.7917,1.5192147,29.6951Q1.5,29.5985,1.5,29.5ZM14.5,29.5L14.5,26.5Q14.5,26.401510000000002,14.4808,26.30491Q14.4616,26.20831,14.4239,26.11732Q14.3862,26.02632,14.3315,25.94443Q14.2767,25.86254,14.2071,25.79289Q14.1375,25.72325,14.0556,25.66853Q13.9737,25.61381,13.8827,25.57612Q13.7917,25.538429999999998,13.6951,25.51921Q13.5985,25.5,13.5,25.5Q13.4015,25.5,13.3049,25.51921Q13.2083,25.538429999999998,13.1173,25.57612Q13.0263,25.61381,12.9444,25.66853Q12.8625,25.72325,12.7929,25.79289Q12.7232,25.86254,12.6685,25.94443Q12.6138,26.02632,12.5761,26.11732Q12.5384,26.20831,12.5192,26.30491Q12.5,26.401510000000002,12.5,26.5L12.5,28.5L10.5,28.5C9.94772,28.5,9.5,28.947699999999998,9.5,29.5C9.5,30.052300000000002,9.94772,30.5,10.5,30.5L13.5,30.5Q13.5985,30.5,13.6951,30.480800000000002Q13.7917,30.4616,13.8827,30.4239Q13.9737,30.386200000000002,14.0556,30.3315Q14.1375,30.276699999999998,14.2071,30.2071Q14.2767,30.1375,14.3315,30.0556Q14.3862,29.9737,14.4239,29.8827Q14.4616,29.7917,14.4808,29.6951Q14.5,29.5985,14.5,29.5Z", fillRule: "evenodd" }) })
] }));

// src/components/file-preview/ViewControl.tsx
import { jsx as jsx9, jsxs as jsxs9 } from "react/jsx-runtime";
var ViewControlContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 25px;
  margin: auto;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 230px;
  border-radius: 6px;
  background: #ffffff;
  padding: 0 10px;
  z-index: 2;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
  .container-item {
    width: 14px;
    height: 14px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    &:hover {
      background: #f5f5f6;
    }
  }
`;
var ViewControl = (props) => {
  return /* @__PURE__ */ jsxs9(ViewControlContainer, { className: "view-control-container", children: [
    props.onEnlarge && /* @__PURE__ */ jsx9("div", { className: "container-item", onClick: props.onEnlarge, children: /* @__PURE__ */ jsx9(SvgFangda, { className: "text-14px" }) }),
    props.onShrink && /* @__PURE__ */ jsx9("div", { className: "container-item", onClick: props.onShrink, children: /* @__PURE__ */ jsx9(SvgSuoxiao, { className: "text-14px" }) }),
    props.onRotate && /* @__PURE__ */ jsx9("div", { className: "container-item", onClick: props.onRotate, children: /* @__PURE__ */ jsx9(SvgChongshi, { className: "text-14px" }) }),
    props.onRestore && /* @__PURE__ */ jsx9("div", { className: "container-item", onClick: props.onRestore, children: /* @__PURE__ */ jsx9(SvgShiyinghuabu, { className: "text-14px" }) }),
    props.onDownload && /* @__PURE__ */ jsx9("div", { className: "container-item", onClick: props.onDownload, children: /* @__PURE__ */ jsx9(SvgXiazai, { className: "text-14px" }) })
  ] });
};
var ViewControl_default = ViewControl;

// src/components/file-preview/Loading.tsx
import { jsx as jsx10 } from "react/jsx-runtime";
function Loading({ className = "" }) {
  return /* @__PURE__ */ jsx10(
    "div",
    {
      className: cn(
        "ui-coms-absolute ui-coms-flex ui-coms-items-center ui-coms-justify-center ui-coms-bg-white ui-coms-w-full ui-coms-h-full ui-coms-z-999 ui-coms-flex-center ui-coms-left-0 ui-coms-top-0 ",
        className
      ),
      children: /* @__PURE__ */ jsx10(
        "img",
        {
          className: "ui-coms-w-[20px] ui-coms-h-[20px] animate-spin  ui-coms-animate-spin",
          src: "https://resource.bantouyan.com/battleyeah-ai/chat-mobile/circle.png"
        }
      )
    }
  );
}

// src/components/file-preview/PdfPreview/NormalPdfPreview.tsx
import "react-pdf/dist/Page/TextLayer.css";
import "react-pdf/dist/Page/AnnotationLayer.css";
import { Fragment, jsx as jsx11, jsxs as jsxs10 } from "react/jsx-runtime";
pdfjs.GlobalWorkerOptions.workerSrc = "https://resource.bantouyan.com/betteryeah/dev/pdfjs/7.6.0/pdfjs.worker.min.js";
var PdfViewContainer = styled2.div`
  display: flex;
  flex: 1;
  height: 100%;
  overflow: scroll;

  .pdf-document {
    height: 100%;

    .ui-coms-pdf-page {
      padding-bottom: 10px;
    }
  }

  .react-pdf__message.react-pdf__message--loading {
    height: 100%;
  }

  .ui-coms-loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .view-control-container {
    opacity: 0;
  }

  &:hover {
    .view-control-container {
      opacity: 1;
    }
  }
`;
var SCALE_STEP2 = 0.2;
var SCALE_LIMIT2 = {
  MAX: 4,
  MIN: 0.5
};
function PdfPreview(props) {
  const { url } = props;
  const [numPages, setNumPages] = useState2(null);
  const [rotate, setRotate] = useState2(0);
  const [scale, setScale] = useState2(1.2);
  const [open, contextHolder] = toast_default();
  const onDocumentLoadSuccess = (e) => {
    setNumPages(e.numPages);
  };
  const handleZoom = (scale2) => {
    if (scale2 > SCALE_LIMIT2.MAX) {
      scale2 = SCALE_LIMIT2.MAX;
    } else if (scale2 < SCALE_LIMIT2.MIN) {
      scale2 = SCALE_LIMIT2.MIN;
    }
    scale2 = Number.parseFloat(`${scale2}`);
    setScale(scale2);
  };
  const onEnlarge = () => {
    handleZoom(scale + SCALE_STEP2);
  };
  const onShrink = () => {
    handleZoom(scale - SCALE_STEP2);
  };
  const onRotate = () => {
    let _rotate = 0;
    if (_rotate !== 270) {
      _rotate = rotate + 90;
    }
    setRotate(_rotate);
  };
  const onRestore = () => {
    setScale(1.2);
  };
  const onDownload = () => {
    const response = download2(url);
    if (response instanceof XMLHttpRequest) {
      response.onerror = function() {
        open({
          type: "error",
          content: "\u4E0B\u8F7D\u5931\u8D25"
        });
      };
    }
  };
  return /* @__PURE__ */ jsxs10(Fragment, { children: [
    /* @__PURE__ */ jsx11(PdfViewContainer, { children: /* @__PURE__ */ jsx11(
      Document,
      {
        className: "ui-coms-document pdf-document ui-coms-flex ui-coms-flex-col ui-coms-flex-1",
        file: url,
        loading: /* @__PURE__ */ jsx11("div", { className: "ui-coms-loading ui-coms-h-full ui-coms-w-full ui-coms-flex ui-coms-items-center ui-coms-justify-center", children: /* @__PURE__ */ jsx11(Loading, {}) }),
        onLoadSuccess: onDocumentLoadSuccess,
        rotate,
        children: Array(numPages).fill(null).map((_, index) => /* @__PURE__ */ jsx11(
          "div",
          {
            className: "ui-coms-w-full ui-coms-flex ui-coms-justify-center",
            children: /* @__PURE__ */ jsx11(
              Page,
              {
                className: "ui-coms-pdf-page pdf-page",
                loading: /* @__PURE__ */ jsx11("div", { className: "ui-coms-loading ui-coms-h-full ui-coms-w-full ui-coms-flex ui-coms-items-center ui-coms-justify-center", children: /* @__PURE__ */ jsx11(Loading, {}) }),
                pageNumber: index + 1,
                scale
              }
            )
          },
          `$page_${index + 1}`
        ))
      }
    ) }),
    /* @__PURE__ */ jsx11(
      ViewControl_default,
      {
        onDownload,
        onEnlarge,
        onRestore,
        onRotate,
        onShrink
      }
    ),
    contextHolder
  ] });
}

// src/components/file-preview/PdfPreview/HighLightPdfPreview.tsx
import styled3 from "@emotion/styled";
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState as useState4
} from "react";
import {
  AreaHighlight,
  Highlight,
  PdfHighlighter,
  PdfLoader,
  Popup
} from "react-pdf-highlighter";

// src/hooks/documentHooks.tsx
import { useMemo, useState as useState3 } from "react";

// src/utils/documentUtils.tsx
function buildChunkHighlights(selectedChunk, size) {
  var _a;
  return Array.isArray(selectedChunk == null ? void 0 : selectedChunk.position) && selectedChunk.position.every((x) => Array.isArray(x)) ? (_a = selectedChunk == null ? void 0 : selectedChunk.position) == null ? void 0 : _a.map((x) => {
    const boundingRect = {
      width: size.width,
      height: size.height,
      x1: x[1],
      x2: x[2],
      y1: x[3],
      y2: x[4]
    };
    return {
      id: `${(/* @__PURE__ */ new Date()).valueOf()}_${Math.random() * 99999}`,
      comment: {
        text: "",
        emoji: ""
      },
      content: { text: selectedChunk.content_with_weight },
      position: {
        boundingRect,
        rects: [boundingRect],
        pageNumber: x[0]
      }
    };
  }) : [];
}

// src/hooks/documentHooks.tsx
function useGetChunkHighlights(selectedChunk) {
  const [size, setSize] = useState3({ width: 849, height: 1200 });
  const highlights = useMemo(() => {
    return buildChunkHighlights(selectedChunk, size);
  }, [selectedChunk, size]);
  const setWidthAndHeight = (width, height) => {
    setSize((pre) => {
      if (pre.height !== height || pre.width !== width) {
        return { height, width };
      }
      return pre;
    });
  };
  return { highlights, setWidthAndHeight };
}

// src/components/file-preview/PdfPreview/HighLightPdfPreview.tsx
import { Fragment as Fragment2, jsx as jsx12, jsxs as jsxs11 } from "react/jsx-runtime";
var PdfViewContainer2 = styled3.div`
  display: flex;
  flex: 1;
  height: 100%;
  overflow: scroll;

  .pdf-document {
    height: 100%;

    .ui-coms-pdf-page {
      padding-bottom: 10px;
    }
  }

  .react-pdf__message.react-pdf__message--loading {
    height: 100%;
  }

  .ui-coms-loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  .view-control-container {
    opacity: 0;
  }

  &:hover {
    .view-control-container {
      opacity: 1;
    }
  }
`;
function HighlightPopup({
  comment
}) {
  return comment.text ? /* @__PURE__ */ jsxs11("div", { className: "Highlight__popup", children: [
    comment.emoji,
    " ",
    comment.text
  ] }) : null;
}
var PdfPreview2 = forwardRef((props, ref) => {
  const { url } = props;
  const [scale, _setScale] = useState4(1);
  const [_open, contextHolder] = toast_default();
  const [hl, setHl] = useState4({});
  const [loaded, setLoaded] = useState4(false);
  const pdfRef = useRef(() => {
  });
  const pdfHighlighterRef = useRef();
  const { highlights: state, setWidthAndHeight } = useGetChunkHighlights(hl);
  useEffect(() => {
    if (state.length > 0 && loaded) {
      setLoaded(false);
      pdfRef.current(state[0]);
    }
  }, [state, loaded]);
  useImperativeHandle(
    ref,
    () => {
      return {
        highlightItem: (dd) => {
          setHl(dd);
        }
      };
    },
    [setHl, ref, state]
  );
  const resetHash = () => {
  };
  const highlightTransform = (...p) => {
    const [highlight, index, setTip, hideTip, isScrolledTo] = p;
    const isTextHighlight = !(highlight.content && highlight.content.image);
    const component = isTextHighlight ? /* @__PURE__ */ jsx12(
      Highlight,
      {
        isScrolledTo,
        position: highlight.position,
        comment: highlight.comment
      }
    ) : /* @__PURE__ */ jsx12(
      AreaHighlight,
      {
        isScrolledTo,
        highlight,
        onChange: () => {
        }
      }
    );
    return /* @__PURE__ */ jsx12(
      Popup,
      {
        popupContent: /* @__PURE__ */ jsx12(HighlightPopup, __spreadValues({}, highlight)),
        onMouseOver: (popupContent) => setTip(highlight, () => popupContent),
        onMouseOut: hideTip,
        children: component
      },
      index
    );
  };
  useEffect(() => {
    var _a, _b;
    const position = (_a = state == null ? void 0 : state[0]) == null ? void 0 : _a.position;
    const pageNumber = position == null ? void 0 : position.pageNumber;
    if (pageNumber) {
      (_b = pdfRef.current) == null ? void 0 : _b.call(pdfRef, state == null ? void 0 : state[0]);
    }
  }, [state, pdfRef]);
  return /* @__PURE__ */ jsxs11(Fragment2, { children: [
    /* @__PURE__ */ jsx12(PdfViewContainer2, { children: /* @__PURE__ */ jsx12(
      PdfLoader,
      {
        url,
        beforeLoad: /* @__PURE__ */ jsx12(Loading, {}),
        errorMessage: /* @__PURE__ */ jsx12("span", { children: "\u52A0\u8F7D\u51FA\u9519" }),
        children: (pdfDocument) => {
          pdfDocument.getPage(1).then((page) => {
            const viewport = page.getViewport({ scale });
            const width = viewport.width;
            const height = viewport.height;
            setWidthAndHeight(width, height);
          });
          return /* @__PURE__ */ jsx12(
            PdfHighlighter,
            {
              pdfScaleValue: String(scale),
              ref: pdfHighlighterRef,
              pdfDocument,
              enableAreaSelection: (event) => event.altKey,
              onScrollChange: resetHash,
              scrollRef: (scrollTo) => {
                pdfRef.current = scrollTo;
                setLoaded(true);
              },
              onSelectionFinished: () => null,
              highlightTransform,
              highlights: state
            }
          );
        }
      }
    ) }),
    contextHolder
  ] });
});
var HighLightPdfPreview_default = PdfPreview2;

// src/components/file-preview/PdfPreview/index.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var PdfPreview3 = forwardRef2((props, ref) => {
  const { pdfType = "normal" } = props;
  if (pdfType === "highlight") {
    return /* @__PURE__ */ jsx13(HighLightPdfPreview_default, __spreadProps(__spreadValues({}, props), { ref }));
  } else {
    return /* @__PURE__ */ jsx13(PdfPreview, __spreadValues({}, props));
  }
});
var PdfPreview_default = PdfPreview3;

// src/components/file-preview/utils.ts
import { invert } from "lodash-es";
var fileTypeMimeMap = {
  md: "text/markdown",
  html: "text/html",
  htm: "text/htm",
  txt: "text/plain",
  css: "text/css",
  js: "application/javascript",
  json: "application/json",
  xml: "application/xml",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  png: "image/png",
  gif: "image/gif",
  svg: "image/svg+xml",
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  mp3: "audio/mpeg",
  mp4: "video/mp4",
  avi: "video/x-msvideo",
  wav: "audio/wav",
  mov: "video/quicktime",
  webm: "video/webm",
  mkv: "video/x-matroska",
  flv: "video/x-flv",
  zip: "application/zip",
  rar: "application/x-rar-compressed"
};
function getFileSuffixByMime(mimeType) {
  if (mimeType.includes("video")) {
    return "video";
  }
  const map = invert(fileTypeMimeMap);
  return map[mimeType];
}

// src/components/file-preview/OfficePreview.tsx
import { useState as useState5 } from "react";
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
function OfficePreview(props) {
  const [loading, setLoading] = useState5(true);
  return /* @__PURE__ */ jsx14("div", { className: "ui-coms-flex-1 ui-coms-w-full ui-coms-h-full ui-coms-flex ui-coms-relative ui-coms-overflow-hidden", children: /* @__PURE__ */ jsxs12("div", { className: "ui-coms-flex-1 ui-coms-w-full ui-coms-h-full ui-coms-relative ui-coms-left--1 ui-coms-top--1px", children: [
    /* @__PURE__ */ jsx14("div", { className: "ui-coms-flex-1 ui-coms-items-center ui-coms-justify-center", children: loading && /* @__PURE__ */ jsx14(Loading, {}) }),
    /* @__PURE__ */ jsx14(
      "iframe",
      {
        className: "ui-coms-border-none ui-coms-flex-1 ui-coms-h-full ui-coms-w-full",
        title: "Excel \u9884\u89C8",
        onLoad: () => {
          setLoading(false);
        },
        src: props.withOfficeService ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
          props.url
        )}` : props.url
      },
      props.url
    )
  ] }) });
}

// src/components/file-preview/MarkdownPreview.tsx
import { useState as useState6, useEffect as useEffect2 } from "react";
import axios from "axios";
import MarkdownIt from "markdown-it";
import styled4 from "@emotion/styled";
import { jsx as jsx15, jsxs as jsxs13 } from "react/jsx-runtime";
var MarkdownPreviewWrapper = styled4.div`
  * {
    line-height: 1.5em;
  }
`;
function MarkdownPreview(props) {
  const [loading, setLoading] = useState6(false);
  const [html, setHtml] = useState6("");
  const { url } = props;
  const [open, contextHolder] = toast_default();
  const fetchContent = () => __async(this, null, function* () {
    var _a;
    setLoading(true);
    try {
      const res = yield axios.get(url);
      const content = (_a = res.data && typeof res.data === "object" ? JSON.stringify(res.data) : res.data) != null ? _a : "";
      const markdownIt = new MarkdownIt({
        linkify: true,
        breaks: true
      });
      const html2 = markdownIt.render(content);
      setLoading(false);
      setHtml(html2);
    } catch (e) {
      open({
        type: "error",
        content: "\u9884\u89C8\u8D44\u6E90\u52A0\u8F7D\u5931\u8D25"
      });
      console.warn("markdown load:::", e);
    }
  });
  useEffect2(() => {
    fetchContent();
  }, [url]);
  return /* @__PURE__ */ jsxs13(MarkdownPreviewWrapper, { className: "ui-coms-relative ui-coms-betteryeah-markdown", children: [
    loading && /* @__PURE__ */ jsx15("div", { className: "ui-coms-absolute ui-coms-flex ui-coms-items-center ui-coms-justify-center ui-coms-w-full ui-coms-h-full ui-coms-bg-bg ui-coms-flex-center ", children: /* @__PURE__ */ jsx15(Loading, { className: "ui-coms-min-h-[80vh]" }) }),
    /* @__PURE__ */ jsx15("div", { dangerouslySetInnerHTML: { __html: html } }),
    contextHolder
  ] });
}

// src/components/file-preview/ImagePreview.tsx
import styled5 from "@emotion/styled";
import { useRef as useRef2 } from "react";
import { jsx as jsx16, jsxs as jsxs14 } from "react/jsx-runtime";
var ImageComp = styled5.img`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  transform: rotate(${(props) => props.rotate}deg);
  flex-shrink: 0;
  max-width: ${(props) => props.width};
  object-fit: contain;
`;
var ImageViewContainer = styled5.div`
  &::-webkit-scrollbar {
    display: none;
  }
`;
function ImagePreview(props) {
  const { url } = props;
  const previewContainer = useRef2(null);
  const { onDownload, onShrink, onRestore, onEnlarge, onRotate, imageStyle } = useImagePreview(url);
  return /* @__PURE__ */ jsxs14("div", { className: "ui-coms-flex-1 ui-coms-h-full ui-coms-w-full ui-coms-overflow-hidden ui-coms-flex ui-coms-relative", children: [
    /* @__PURE__ */ jsx16(
      ImageViewContainer,
      {
        ref: previewContainer,
        className: "ui-coms-w-full ui-coms-h-full ui-coms-flex-1 ui-coms-overflow-scroll ui-coms-relative",
        children: /* @__PURE__ */ jsx16(
          ImageComp,
          {
            alt: "",
            className: "ui-coms-select-none ui-coms-absolute ui-coms-top-0 ui-coms-bottom-0 ui-coms-right-0 ui-coms-left-0  ui-coms-inline-block ui-coms-m-auto",
            height: imageStyle.height,
            rotate: imageStyle.rotate,
            src: url,
            width: imageStyle.width
          }
        )
      }
    ),
    /* @__PURE__ */ jsx16(
      ViewControl_default,
      {
        onDownload,
        onEnlarge,
        onRestore,
        onRotate,
        onShrink
      }
    )
  ] });
}

// src/components/file-preview/VideoPreview.tsx
import styled6 from "@emotion/styled";
import { useEffect as useEffect3 } from "react";
import Player from "xgplayer";
import "xgplayer/dist/index.min.css";
import { jsx as jsx17 } from "react/jsx-runtime";
var VideoPreviewWrapper = styled6.div`
  display: flex;
  width: 100%;
  height: 100%;
`;
function VideoPreview(props) {
  const { url } = props;
  useEffect3(() => {
    if (url) {
      new Player({
        height: "100%",
        width: "100%",
        id: "__bty_dataset_video_preview_player__",
        url,
        lang: "zh-cn",
        ignores: ["FullScreen", "CssFullScreen", "PlaybackRate"]
      });
    }
  }, [url]);
  return /* @__PURE__ */ jsx17(VideoPreviewWrapper, { children: /* @__PURE__ */ jsx17(
    "div",
    {
      id: "__bty_dataset_video_preview_player__",
      className: "relative w-100% h-100% flex-1"
    }
  ) });
}

// src/components/file-preview/FailBack.tsx
import { jsx as jsx18 } from "react/jsx-runtime";
function FailBack(props) {
  return /* @__PURE__ */ jsx18(
    "div",
    {
      className: cn(
        "ui-coms-p-[24px] ui-coms-flex ui-coms-c-font_1 ui-coms-bg-white ui-coms-justify-center ui-coms-h-full",
        props.className
      ),
      children: props.message
    }
  );
}

// src/components/file-preview/index.tsx
import { jsx as jsx19, jsxs as jsxs15 } from "react/jsx-runtime";
var ViewMap = {
  pdf: PdfPreview_default,
  ppt: PdfPreview_default,
  pptx: PdfPreview_default,
  xlsx: OfficePreview,
  xls: OfficePreview,
  doc: OfficePreview,
  docx: OfficePreview,
  txt: MarkdownPreview,
  md: MarkdownPreview,
  jpg: ImagePreview,
  png: ImagePreview,
  jpeg: ImagePreview,
  svg: ImagePreview,
  video: VideoPreview
};
var FilePreview = forwardRef3((props, ref) => {
  var _a;
  const {
    url,
    className,
    mimetype,
    loadingNode = /* @__PURE__ */ jsx19(Loading, {}),
    ossConfig,
    withOfficeService = true,
    extra = {}
  } = props;
  const [fileExists, setFileExists] = useState7(false);
  const [loading, setLoading] = useState7(true);
  const comRef = useRef3();
  const fileUrl = useMemo2(() => {
    if (ossConfig == null ? void 0 : ossConfig.signatureUrl) {
      return ossConfig.signatureUrl(url);
    } else {
      return url;
    }
  }, [url]);
  useEffect4(() => {
    if (ossConfig == null ? void 0 : ossConfig.checkFileExist) {
      ossConfig.checkFileExist(url).then(() => {
        setFileExists(true);
      }).finally(() => setLoading(false));
    } else {
      setFileExists(true);
      setLoading(false);
    }
  }, []);
  const type = (_a = getFileSuffixByMime(mimetype)) != null ? _a : "txt";
  const isNoSupportLocalFile = type === "docx" && (url == null ? void 0 : url.startsWith("blob:"));
  const Component = useMemo2(() => {
    return !isNoSupportLocalFile && ViewMap[type] || void 0;
  }, [isNoSupportLocalFile, type]);
  useImperativeHandle2(
    ref,
    () => {
      return comRef.current;
    },
    [ref, comRef.current, Component]
  );
  return /* @__PURE__ */ jsx19(
    "div",
    {
      className: cn(
        "ui-coms-flex-1 ui-coms-h-full ui-coms-relative ui-coms-p-[24px] ui-coms-overflow-hidden ui-coms-box-border",
        className,
        {
          "ui-coms-px-[40px]": type === "txt"
        }
      ),
      children: /* @__PURE__ */ jsxs15("div", { className: "ui-coms-overflow-auto ui-coms-h-[100%]", children: [
        !Component && /* @__PURE__ */ jsx19(
          FailBack,
          {
            className: "ui-coms-w-full",
            message: "\u6682\u4E0D\u652F\u6301\u8BE5\u6587\u4EF6\u7C7B\u578B\u7684\u9884\u89C8"
          }
        ),
        !fileExists && /* @__PURE__ */ jsx19(FailBack, { message: "\u6587\u4EF6\u5DF2\u8FC7\u671F\u88AB\u6E05\u7406" }),
        loading && loadingNode,
        Component && fileExists && /* @__PURE__ */ jsx19(
          Component,
          {
            withOfficeService,
            url: fileUrl,
            ref: comRef,
            pdfType: extra == null ? void 0 : extra.pdfType
          }
        )
      ] })
    }
  );
});

// src/components/schema-form/SchemaForm.tsx
import Form from "rc-field-form";
import { useDeepMemo } from "@bty/ai-shared";
import { jsx as jsx20 } from "react/jsx-runtime";
function SchemaForm(props) {
  const _a = props, { schema, fieldComponentsMap, disabled } = _a, restProps = __objRest(_a, ["schema", "fieldComponentsMap", "disabled"]);
  const memoSchema = useDeepMemo(() => schema, [schema]);
  const render = (schemaValue, control, meta) => {
    const Component = fieldComponentsMap[schemaValue.type];
    if (!Component) {
      console.error(
        "[Schema Form]: \u672A\u627E\u5230\u8BE5Schema\u5BF9\u5E94\u7684\u7EC4\u4EF6: ",
        schemaValue.type
      );
      return;
    }
    return Component(schemaValue, control, meta);
  };
  return /* @__PURE__ */ jsx20(Form, __spreadProps(__spreadValues({}, restProps), { children: memoSchema.map((schemaValue, index) => /* @__PURE__ */ jsx20(
    Form.Field,
    {
      name: schemaValue.name,
      rules: [
        {
          required: !!schemaValue.required,
          message: `${schemaValue.label}\u4E0D\u80FD\u4E3A\u7A7A`
        }
      ],
      children: (control, meta) => render(schemaValue, control, __spreadProps(__spreadValues({}, meta), {
        disabled,
        index
      }))
    },
    schemaValue.name
  )) }));
}
SchemaForm.useForm = Form.useForm;
export {
  FilePreview,
  SchemaForm,
  useImagePreview
};
